
import { reactive } from "vue";

let currentErrorMessage = "";

export const store = reactive({
    dealerSelected: sessionStorage.getItem('dealerSelected') || '',
    memberSite:'',
    siteSelected: sessionStorage.getItem('siteSelected') || '',
    dealerData: [],
    dealerContextLoaded: false,
    dealerContextLoading: null,
    otpCheck: true,
    attributeKey:'',
    attributeValue:'',
    get errorMessage() {
      return currentErrorMessage;
    },
    set errorMessage(message) {
      currentErrorMessage = message || "";
      if (currentErrorMessage) {
        this.addNotification(currentErrorMessage, "error");
      }
    },
    errorStatus: 0,
    siteData: [],
    notifications: [], // For Toast system
    
    addNotification(message, type = 'info', duration = 3000) {
      const existing = this.notifications.find(
        (notification) => notification.message === message && notification.type === type,
      );
      if (existing) return existing.id;
      const id = Date.now();
      this.notifications.push({ id, message, type });
      if (duration > 0) {
        setTimeout(() => {
          this.removeNotification(id);
        }, duration);
      }
      return id;
    },
    
    removeNotification(id) {
      const index = this.notifications.findIndex(n => n.id === id);
      if (index !== -1) {
        this.notifications.splice(index, 1);
      }
    }
  });
